import { useEffect } from 'react';
import { Link, useLocation } from 'react-router';
import { useDiagnostics } from '../diagnostics/context';
import { useI18n } from '../i18n/i18n';
import { PageHeading, useDocumentTitle } from './page';

export function NotFound() {
  const logger = useDiagnostics();
  const { t, errorMessage } = useI18n();
  const { pathname } = useLocation();
  useDocumentTitle(t('notFound.title'));

  useEffect(() => {
    logger.warn('web-nav', 'Unknown route requested', {
      code: 'WEB-NAV-001',
      origin: 'apps/web/src/app/NotFound.tsx:NotFound',
      context: { route: pathname.slice(0, 120) },
    });
  }, [logger, pathname]);

  return (
    <div className="narrow">
      <PageHeading>{t('notFound.title')}</PageHeading>
      <p>{errorMessage('WEB-NAV-001')}</p>
      <p>
        <Link to="/">{t('notFound.back')}</Link>
      </p>
    </div>
  );
}
